import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {map} from 'rxjs/operators';
import {IAcaoPerfil} from '../models/acao-perfil.model';

const perfil: IAcaoPerfil[] = [
  {id: 0, nome: 'acao_tatica', caption: 'Ação Tática'},
  {id: 1, nome: 'acao_estrategica', caption: 'Ação Estratégica'},
  {id: 2, nome: 'acao_operacional', caption: 'Ação Operacional'}
];

@Injectable()
export class AcaoPerfilService {
  getAcaoPerfil(): Observable<IAcaoPerfil[]> {
    return Observable.from(perfil)
      .pipe(map(data => {
        return <IAcaoPerfil>data;
      }))
      .toArray();
  }
}

